module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-18.5f88ac2.woff2";